import * as React from 'react';
import { ScheduleDivider } from '../../page-styles/schedule.style';
import { colors } from '../../style/colors';
import ColoredRow from '../colored-row/ColoredRow';
import InfoRow from '../info-row/InfoRow';
const ScheduleTable = ({ isInPerson, schedule }) => {
  const {
    document: {
      data: { body: rows },
      id,
    },
  } = schedule;

  const numColoredRows = rows.filter(r => r.slice_type === 'colored_row')
    .length;

  const rowColors = () => {
    let toReturn = [];
    for (let i = 0; i < numColoredRows; i++) {
      if (i % 2 == 0) {
        toReturn.push({ rowColor: colors.MUSTARD, textColor: colors.BLACK });
      } else {
        toReturn.push({ rowColor: colors.PERIWINKLE, textColor: colors.WHITE });
      }
    }
    return toReturn;
  };

  let currColoredRowIndex = 0;
  for (let i = 0; i < rows.length; i++) {
    if (rows[i].slice_type === 'colored_row') {
      rows[i].colors = rowColors()[currColoredRowIndex];
      currColoredRowIndex++;
    }
  }

  for (let i = 0; i < rows.length; i++) {
    if (
      i === 0 ||
      (rows[i - 1].slice_type === 'row' &&
        rows[i].primary.time.text !== rows[i - 1].primary.time.text)
    ) {
      rows[i].line = true;
    } else {
      rows[i].line = false;
    }
  }

  for (let i = 1; i < rows.length; i++) {
    if (rows[i].primary.time.text === rows[i - 1].primary.time.text) {
      rows[i].sameTime = true;
    } else {
      rows[i].sameTime = false;
    }
  }

  return (
    <>
      {rows.map(r => {
        if (r.slice_type === 'colored_row') {
          return <ColoredRow key={r.id} rowData={r} />;
        }
        if (r.line) {
          return (
            <div key={r.id}>
              <ScheduleDivider isInPerson={isInPerson} />
              <InfoRow rowData={r} isInPerson={isInPerson} />
            </div>
          );
        } else {
          return <InfoRow key={r.id} rowData={r} isInPerson={isInPerson} />;
        }
      })}
    </>
  );
};
export default ScheduleTable;
